import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

//import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import MainPotalForm from './components/main_portal_form';

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    //return !!localStorage.getItem("token");
    return !!sessionStorage.getItem("token");
  });

  const user = JSON.parse(sessionStorage.getItem("user") || "null");

  useEffect(() => {
    //const token = localStorage.getItem("token");
    const token = sessionStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  return (
    <Router>
      <Routes>

        {/* LOGIN */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          }
        />

        {/* CHANGE PASSWORD */}
        <Route
          path="/change-password"
          element={
            isAuthenticated ? (
              <ChangePassword />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* DASHBOARD */}
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              user?.must_change_password ? (
                <Navigate to="/change-password" />
              ) : (
                <MainPotalForm />
              )
            ) : (
              <Navigate to="/" />
            )
          }
        />

      </Routes>
    </Router>
  );
}


//Example of how to use the ProtectedRoute component for role-based access control:
//import ProtectedRoute from "./components/ProtectedRoute";
//  <Route
//   path="/user-management"
//   element={
//     <ProtectedRoute allowedRoles={["ADMIN"]}>
//       <UserManagement />
//     </ProtectedRoute>
//   }
// />

//ADMIN → can open page ✅
//others → blocked ❌



export default App;